import { useCallback, useMemo } from "react";
import { SidePanelDS, Spacer } from "@qivia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useAppSelector } from "../../../../redux/hooks";
import { selectElectricCharges } from "../electricChargingSlice";
import { SidePanelHeader } from "./sidePanelHeader";
import { SidePanelSectionBlock } from "./sectionBlock";
import { SidePanelReimburse } from "./sidePanelReimburse";
import { SidePanelRefunded } from "./sidePanelRefunded";
import "../../../../i18n/i18n";

export const ChargingSidePanel = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const electricCharges = useAppSelector(selectElectricCharges);

  const charge = electricCharges.find((c) => c.uuid === params.id) ?? null;

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/electric_charging/charging_tracking`);
  }, [firstPath, navigate]);

  const reimbursableAmount = useMemo(
    () => (charge?.refundStatus === "TO_REFUND" ? charge.refundAmount : null),
    [charge],
  );

  const isRefunded = useMemo(
    () => charge?.refundStatus === "REFUNDED",
    [charge],
  );

  if (!charge) {
    return;
  }

  return (
    <SidePanelDS.SidePanel
      visible={!!charge}
      onClose={onSidePanelClosed}
      absoluteSection={
        reimbursableAmount !== null ? (
          <SidePanelReimburse
            charge={charge}
            refundAmount={reimbursableAmount}
          />
        ) : undefined
      }
    >
      <SidePanelDS.Section
        verticalSpacing={1.5}
        horizontalSpacing={1.5}
        background={colors["colors/button/secondary/hover"]}
      >
        <SidePanelHeader charge={charge} />
        <Spacer y={1} />
        <SidePanelSectionBlock charge={charge} firstPath={firstPath} />
      </SidePanelDS.Section>
      {isRefunded && (
        <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
          <SidePanelRefunded charge={charge} />
        </SidePanelDS.Section>
      )}
    </SidePanelDS.SidePanel>
  );
};
